/**
 * User Center Client Mod — 注册器
 *
 * 通过 DI 获取 UI Registry 服务，注册用户中心页面路由。
 */
import { USER_CENTER_PATH } from '@hvsin/user-center-contracts';
import { UserCenterPage } from './pages/user-center-page.js';
/**
 * 用户中心注册器
 *
 * 将用户中心页面注册到路由系统中，并注入 slots service。
 */
export class UserCenterRegistrar {
    constructor(deps) {
        const { pageRouteRegistry, userCenterSlots } = deps;
        // ─── 注册用户中心页面路由 ───
        pageRouteRegistry.registerPage({
            path: USER_CENTER_PATH,
            component: () => UserCenterPage({ slotsService: userCenterSlots }),
            key: 'user-center',
            meta: {
                title: '用户中心',
                requiresAuth: true,
            },
            modName: 'user-center-client',
        });
    }
}
//# sourceMappingURL=user-center-registrar.js.map